import React, { useState } from "react";
import styles from "./DesignSettings/DesignSettingsFont.module.css";

import { generateFontsTagsFromDesignContext } from "../utils/FontUtils";

const FontPreview = ({
  designContext,
  fontName,
  font,
  onClickRemove,
  justShowPreview = false,
  unsaved = false,
}) => {
  const getFontStyle = () => {
    const name = font.get("name", "");
    const family = font.get("family", "");
    const style = name.replace(family, "").trim();
    return style ? `${style} |` : "";
  };

  const _getFontTags = () => {
    const tags = [];

    if (font && font.get("family")) {
      tags.push(...generateFontsTagsFromDesignContext([font.toJS()], designContext));
    }

    const css = "html, body {padding:0;margin:0;} div {box-sizing:border-box}";

    tags.push(
      <style key="page-style" type="text/css">
        {css}
      </style>
    );

    return {
      tags,
    };
  };

  const fontInfo = _getFontTags();
  const css = ".removeBtn {opacity:0.5;} .removeBtn:hover {opacity:1;cursor:pointer;}";

  fontInfo.tags.push(
    <style key="btn-style" type="text/css">
      {css}
    </style>
  );

  const headerStyle = {
    display: "none",
  };

  const activeFontTextStyle = {
    fontFamily: `"${font.get("family", fontName)}"`,
    fontWeight: font.get("weight", 400),
  };

  const fontStyle = font.get("style", false);
  if (fontStyle) {
    activeFontTextStyle.fontStyle = fontStyle;
  }

  if (justShowPreview) {
    return (
      <>
        <div style={headerStyle}>{fontInfo.tags}</div>
        <span className={styles["active-font-text"]} style={activeFontTextStyle}>
          {fontName}
        </span>
      </>
    );
  }

  return (
    <div className={styles["active-font-preview-wrapper"]}>
      <div className={styles["active-font-left"]}>
        <div style={headerStyle}>{fontInfo.tags}</div>
        <div className={styles["active-font-text"]} style={activeFontTextStyle}>
          <span>{fontName}</span>
        </div>
        <div className={styles["active-font-meta-text"]}>
          <span>
            {font.get("family", "")} | {getFontStyle()} {font.get("type", "")}{" "}
            {unsaved && (
              <span>
                | <span className={styles["unsaved-font-text"]}>Unsaved Font</span>
              </span>
            )}
          </span>
        </div>
      </div>
      {onClickRemove !== undefined && (
        <div className={styles["active-font-right"]}>
          <span
            title="Remove font"
            onClick={() => onClickRemove(font.get("name"))}
            className={styles["remove-btn"]}
          >
            &times;
          </span>
        </div>
      )}
    </div>
  );
};

export default FontPreview;
